<script>
  import Loader from '../../Common/Loader.svelte';
  import Checkbox from '../../Common/Checkbox.svelte';
  import { External, M } from '../../external';
  import NoDataPlaceholder from '../../Common/NoDataPlaceholder.svelte';
  import { onMount } from 'svelte';
  import { makeLmsRequest } from '../service/LmsClient';
  import { ignore } from '../../Common/tools';

  export let selectedIds = [], onChange = ignore;

  let loading = true;
  let selectedCategories = [];
  let categories = [];

  let addCategory = () => {
    External.Tools.promptForInput(M.CREATE_NEW_CATEGORY, M.ENTER_CATEGORY_NAME, '', async (name) => {
      let result = await makeLmsRequest('/category', 'POST', {
        name: name,
        uiOrder: categories.length ? categories[categories.length - 1].uiOrder + 100 : 100
      });
      if (result.ok) {
        let category = await result.json();
        categories.push(category);
        categories = categories;
      }
    });
  };

  let showSettings = (target, category) => {
    const items = [
      {
        text: M.RENAME,
        icon: 'fa-pencil',
        tag: 'rename'
      },
      {
        text: M.DELETE,
        icon: 'fa-trash',
        tag: 'delete'
      }
    ];

    External.Tools.showTooltipOptions(target, items, (target, idx, text, tag) => {
      switch (tag) {
        case 'rename':
          editCategory(category);
          break;
        case 'delete':
          deleteCategory(category);
          break;
      }
    });
  };

  let deleteCategory = (category) => {
    External.Tools.prompt(M.DELETE, M.DEL_CONFIRM, async () => {
      await makeLmsRequest(`/category/${category.id}`, 'DELETE');
      categories = categories.filter(cat => cat.id !== category.id);
    });
  };

  let editCategory = (category) => {
    External.Tools.promptForInput(M.RENAME_CATEGORY, M.ENTER_CATEGORY_NAME, category.name, async (name) => {
      category.name = name;
      await makeLmsRequest(`/category/${category.id}`, 'PUT', category);
      categories = categories;
    });
  };

  let toggleSelectCategory = (category, selected) => {
    if (selected) {
      selectedCategories.push(category.id);
    } else {
      selectedCategories = selectedCategories.filter(catId => catId !== category.id);
    }
    onChange(selectedCategories);
  };

  let setupSortable = (node) => {

    let jqSortable = External.$(node);
    jqSortable.sortable({
      items: '.product-select-wrapper',
      handle: '.move-handle',
      containment: 'parent',
      tolerance: 'pointer',
      axis: 'y',
      start: (event, ui) => {
        ui.item.data('idx', ui.item.index());
      },
      stop: (event, ui) => {
        let newIdx = ui.item.index();
        let oldIdx = ui.item.data('idx') || 0;
        if (newIdx !== oldIdx) {
          let item = categories[oldIdx];
          categories.splice(oldIdx, 1);
          categories.splice(newIdx, 0, item);

          let lowerOrder = newIdx - 1 >= 0 ? categories[newIdx - 1].uiOrder : 0;
          let higherOrder = newIdx + 1 < categories.length ? categories[newIdx + 1].uiOrder : (lowerOrder + 100);
          item.uiOrder = (lowerOrder + higherOrder) / 2;
          makeLmsRequest(`/category/${item.id}`, 'PUT', item);
        }
      }
    });
    return {
      destroy: () => {
        jqSortable.sortable('destroy');
        jqSortable = null;
      }
    };
  };

  onMount(async () => {
    loading = true;
    let result = await makeLmsRequest('/category/all');
    if (result.ok) {
      categories = await result.json();
    }
    selectedCategories = categories.filter(cat => selectedIds.includes(cat.id)).map(cat => cat.id);
    loading = false;
  });
</script>
<div class="popup-widget-wrapper">
  <div class="f-left t-center mt-15 col20">
    {#if loading}
      <Loader compact={true} />
    {:else}
      {#if categories.length === 0}
        <NoDataPlaceholder message="{M.NO_CATEGORIES_FOUND}" />
      {:else}
        <div class="col20 f-left">
          <h3 class="col20 f-left mt-25 ta-center">{M.SELECT_CATEGORY}</h3>
          <div class="col20 f-left mt-15" use:setupSortable>
            {#each categories as category(category)}
              <div class="col20 mt-5 f-left gray-section product-select-wrapper flex flex-row align-center space-between mb-0 hover-parent">
                <Checkbox
                  data={selectedCategories.includes(category.id)}
                  onChange={(isChecked) => toggleSelectCategory(category, isChecked)}
                  label={category.name}
                  clz="ta-left mb-0 flex-1" />

                <div class="move-handle button-tooltip hover-target" data-tooltip="simpleMove">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path
                      d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                  </svg>
                </div>
                <a data-tooltip="settings" class="button-tooltip hover-target flex-none ml-5"
                   on:click={(event) => showSettings(event.target, category)}>
                  <i class="material-icons-outlined">settings</i>
                </a>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    {/if}
  </div>
  <div class="col20 f-left t-center mt-15 mb-15">
    <a on:click={addCategory} class="middle-button blue with-icon inline-block f-none">{M.ADD_CATEGORY}</a>
  </div>
</div>
